/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const FieldR = t.interface({});

// optional attributes
const FieldO = t.partial({
  type: t.string,

  class: t.string,

  id: t.string,

  src: t.string
});

export const Field = t.intersection([FieldR, FieldO], "Field");

export type Field = t.TypeOf<typeof Field>;
